export default __webpack_public_path__ + "static/media/108-employee.fd1f9af2.svg";